export default __webpack_public_path__ + "static/media/corporationIcon.2932405a.svg";